import { render, staticRenderFns } from "./GoodsCase.vue?vue&type=template&id=245b3dbb&scoped=true&"
import script from "./GoodsCase.vue?vue&type=script&lang=js&"
export * from "./GoodsCase.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCase.vue?vue&type=style&index=0&id=245b3dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b3dbb",
  null
  
)

export default component.exports